import accordion from "./accordion";
import burger from "./burger";
import header from "./header";
import menu from "./menu";
import overlap from "./overlap";
import tabs from "./tabs";
import toggle from "./toggle";
import lightbox from "./lightbox";
import language from "./language";
import alert from "./alert";

overlap();
tabs();
burger();
header();
toggle();
accordion();
lightbox();
alert();

const teasers = document.querySelectorAll(".paragraph-teaser");

for (const teaser of teasers) {
  const link = teaser.querySelector(".button2");

  link.addEventListener("mouseenter", (e) => {
    teaser.classList.add("is-hover");
  });
  link.addEventListener("mouseleave", (e) => {
    teaser.classList.remove("is-hover");
  });
}

Drupal.behaviors.exampleModule = {
  attach: function (context, settings) {
    menu();
    language();
  },
};
